<template>
    <div>
        <div class="card">
            <div class="card-header text-black p-2">Tickets</div>
            <div class="card-body p-2">
                <div class="overflow-auto" style="max-height: 300px;">
                    <table class="table hm-fs-12 align-middle table-hover table-sm mb-0">
                        <thead>
                            <tr class="sticky-top">
                                <th class="bg-theme">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-if="Object.keys(openTickets).length > 0"
                                v-for="(ticket, index) in openTickets"
                            >
                                <td @click="$goToPage('/admin/tickets/discussion/' + ticket.uuid)" class="cursor-pointer">
                                    <div class="d-flex justify-content-between">
                                        <span class="text-capitalize">{{ ticket.title }}</span>
                                        <span class="text-capitalize">{{ $dateTimeFormat(ticket.created_at, 'DD MMM, YYYY') }}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else-if="isLoadingOpenTickets">
                                <td class="text-center">Loading...</td>
                            </tr>
                            <tr v-else>
                                <td class="text-center">No open tickets found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TicketSummary',
    data() {
        return {
            openTickets: [],
            isLoadingOpenTickets: true
        }
    },
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            let self = this;
            axios.post('/admin/dashboard/stats?action=open_tickets', {action: 'open_tickets'})
                .then(response => {
                    // Get order summary
                    self.openTickets = response.data;
                    self.isLoadingOpenTickets = false;
                });
        },
    }
};
</script>
